import React, { useEffect } from "react";

import { LANGUAGE, SPEED_TEST_RESULT } from "@/Utils/Constants";
import { getMessage, replaceTranslationDataToResources, changeLanguage } from "CONFIG/i18n";
import { removeTrailingSlash } from "Utils/Utility"
import store from "REDUX/store";
import i18n from "CONFIG/i18n";
import { organisationAction } from "@/Config/ActionFactory";

// Components
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

import { Row, Col, Button } from "reactstrap";
import "./StartSupportCenterSession.less";
import { concatAll } from "rxjs";

const StartSupportCenterSession = (props) => {
  const description = props.description.map((item, index) => {
    return (
      <div key={"key" + index.toString()}>
        {item ? <>{item}</> : <br />}
      </div>
    );
  });

  useEffect(() => {
    updateTenantLanguage();
    changeLanguage();
  }, []);

  const updateTenantLanguage = () => {
    if (!props.gottenWording && !props.isWordingGotten) {
      if ("/" + (removeTrailingSlash(window.location.pathname).split("/"))[1] === store.getState().UserReducer.uriIdentifier) {
        getOrgWording();
      }
    } else if (props.gottenWording && props.isWordingGotten) {
      getOrgWording();
    }
  }

  const getOrgWording = () => {
    organisationAction.getOrgWordingUrlAction('', (removeTrailingSlash(window.location.pathname).split("/"))[1]).then(
      response_data => {
        replaceTranslationDataToResources(props.onChangeLanguage);
      },error => {
      }
    );
  };

  const renderSpeedTestLoadingMessage = () => {
    if (props.speedTestRemainingTime > 0) {
      return (
        <div className="speedTest">
          {`${getMessage("SPEED_TEST_RUNNING")} ${getMessage("REMAINING_TIME", {sec: props.speedTestRemainingTime})}`}
        </div>
      );
    } else {
      return (
        <div className="speedTest">
          {getMessage("SPEED_TEST_PLEASE_WAIT")}
        </div>
      );
    }
  }
  const renderSpeedResultMessage = () => {
    let resultMessage;
    if (props.ownSpeedTestError) {
      // timeout
      resultMessage = getMessage(
        "SPEED_TEST_TIME_OUT_GUEST",
        { speedTestTimeoutSeconds: window._env_.SPEED_TEST_TIMEOUT_MSEC / 1000 }
      );
    } else if (props.speedTestResult === -1) {
      // speed test error
      resultMessage = getMessage("SPEED_TEST_FAILURE_MESSAGE_GUEST");
    } else {
      resultMessage = props.speedTestResult !== undefined && 
      getMessage(Object.keys(SPEED_TEST_RESULT).find((key) => {
        return (SPEED_TEST_RESULT[key] === props.speedTestResult);
      }));
    }
    return (
      <div className="speedTestResult">
        {`${getMessage("CONNECTION_STATUS")}: ${resultMessage}`}
      </div>
    );
  }
  return (
    <>
      <HeaderContainer />
      <div className="startSupportCenterSession">
        <section>
          <div className="languageSelection">
            <div className="mt-1">
              <ChangeLanguage
                onSelectChange={props.onChangeLanguage}
                language={props.language}
              />
            </div>
          </div>
          <div className="px-2">
            <div className="sessionImgArea col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
              <div className="col-4 p-0 d-flex flex-column">
                <Row className="noMargin">
                  <div className="text-center pt-5">
                  </div>
                </Row>
              </div>
            </div>
            <Row className="noMargin">
              <Col xs={12} md={12} className="text-center">
                <p></p>
              </Col>
            </Row>
            <div className="flexDirectionColumn noMarginForMobile inputForm inputFormForWaiting justifyContentFlexCenter alignItemsCenter mx-5">
              {props.isSpeedTestRunning ?
                renderSpeedTestLoadingMessage():
                <span className="description">
                  {description}
                </span>
              }
              <span className="roundLoaderContainer">
                {(props.shouldShowLoader || props.isSpeedTestRunning) && (
                  <div className="roundLoader"></div>
                )}
              </span>
              <br />
              {props.sessionName ? (
                <span className="sessionName">
                  {props.sessionName}
                </span>
              ) : null}
              {!props.isSpeedTestRunning && renderSpeedResultMessage()}
              {props.shouldShowCancel && (
                <>
                  <br />
                  <div className="permissionButtons">
                    <Button
                      className="buttons borderBtn bgwhite mr-2"
                      onClick={props.onCancelClick}
                    >
                      {getMessage("CANCEL")}
                    </Button>
                  </div>
                </>
              )}
              {props.errorMessage && (
                <div className="errorMessage pt-4">
                  {props.errorMessage}
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default StartSupportCenterSession;
